// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__10L5Z","col":"styles_col__Oc4HX","fulfillmentStatus":"styles_fulfillmentStatus__2xJCR","emailCol":"styles_emailCol__2Z1fI"};